




















































import {Component, Mixins} from 'vue-property-decorator'
import SolutionCard from '@/components/cards/SolutionCard.vue'
import PlaceholderCard from '@/components/cards/PlaceholderCard.vue'
import onLocaleChangeMixin from '@/mixins/onLocaleChangeMixin'
import {ISolution} from '@/entities'
import {updateItems} from '@/lib'

@Component({
  components: {
    SolutionCard,
    PlaceholderCard
  }
})
export default class SolutionsPreviewSection extends Mixins(onLocaleChangeMixin) {

  protected initFetches = [
    this.fetchSolutions
  ];

  protected reFetches = [
    this.updateSolutions
  ];

  protected fetching: boolean = false;
  private solutions: ISolution[] = [];

  get solutionsToShow(): ISolution[] {
    return this.solutions.filter((solution: ISolution) => solution.validate());
  }

  private fetchSolutions(): void {
    this.fetching = true;
    this.$storage.actions.fetchSolutions()
      .then(res => {
        this.solutions = res;
      })
      .catch(() => {})
      .finally(() => {
        this.fetching = false;
      });
  }

  private updateSolutions(): void {
    updateItems(this.solutions, this.$storage.actions.getSolutionById);
  }

  get mayHaveItems(): boolean {
    return !!this.solutionsToShow.length || this.fetching;
  }

}
